import React from 'react';

const PriceTag = ({ price, salePrice, size = 'md' }) => {
  const textSize = size === 'lg' ? 'text-2xl' : 'text-base';
  const hasDiscount = salePrice !== null && salePrice !== undefined && salePrice < price;

  return (
    <div className="flex items-baseline gap-2">
      <span className={`${textSize} font-semibold text-slate-900`}>
        € {(hasDiscount ? salePrice : price).toFixed(2)}
      </span>
      {hasDiscount && (
        <span className="text-sm text-slate-400 line-through">€ {price.toFixed(2)}</span>
      )}
    </div>
  );
};

export default PriceTag;
